import { render } from "./ChannelFilter.vue?vue&type=template&id=533bb862&scoped=true&ts=true"
import script from "./ChannelFilter.vue?vue&type=script&lang=ts"
export * from "./ChannelFilter.vue?vue&type=script&lang=ts"

import "./ChannelFilter.vue?vue&type=style&index=0&id=533bb862&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-533bb862"]])

export default __exports__